import httpClient from './httpClient';
const prefix = 'core'

export default {
    async getAll () {
        const { data } = await httpClient({ requiresAuth: true }).get(`/${prefix}/companyType/getAll`)
    
        return data
      }
}